import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FieldValues } from 'react-hook-form';

import { MultiSelectField } from 'common/forms/Field';
import { INotificationTargets } from 'graphql/types';
import { asTypedControl } from 'common/utils/form';
import { TControllerProps } from 'common/types';

interface IProps {
    name: string;
}

export const NotificationTargetsSelectField = <
    TFieldValues extends FieldValues,
>({
    name,
    control: formControl,
}: IProps & TControllerProps<TFieldValues>) => {
    const control = asTypedControl<string[] | undefined>(name, formControl);

    const [translate] = useTranslation();

    const notificationTargetOptions = useMemo(
        () => [
            {
                label: translate(
                    'certificateForm.notificationTargetOptions.participant'
                ),
                value: INotificationTargets.Participant,
            },
            {
                label: translate(
                    'certificateForm.notificationTargetOptions.manager'
                ),
                value: INotificationTargets.Manager,
            },
            {
                label: translate(
                    'certificateForm.notificationTargetOptions.trainer'
                ),
                value: INotificationTargets.Trainer,
            },
        ],
        [translate]
    );

    const optionValues = notificationTargetOptions.map(
        (option) => option.value
    );

    const getOptionLabel = (optionValue: string) =>
        notificationTargetOptions.find(
            (notificationTargetOption) =>
                notificationTargetOption.value === optionValue
        )?.label || '';

    return (
        <MultiSelectField
            control={control}
            getOptionLabel={(optionValue) =>
                getOptionLabel(optionValue as string)
            }
            InputProps={{
                label: translate('certificateForm.notificationTargets'),
            }}
            name={name}
            options={optionValues}
        />
    );
};
